module.exports = __webpack_public_path__ + "static/img/brand_8.bbe5930.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/brand_8.jpg
// module id = BOd8
// module chunks = 1